import Vue from 'vue';
import Alert from '../components/alerta.component.vue';
import Cartao from '../components/cartao.component.vue';
import CartaoMensagem from '../components/cartao.mensagem.component.vue';
import Registrar from '../components/registrar.component.vue';

import 'primevue/resources/themes/bootstrap4-light-blue/theme.css';
import 'primevue/resources/primevue.css';
import 'primeicons/primeicons.css';
// optei por colocar no webpack
// import 'primeicons/fonts/primeicons.ttf';
// import 'primeicons/fonts/primeicons.woff';

// não está compilando as fontes e css do pacote primevue
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Toast from 'primevue/toast';
import Tooltip from 'primevue/tooltip';

import axios from 'axios'
import VueAxios from 'vue-axios'

import './alerta.vue';

window.$ = window.JQuery = require("jquery")

import { ZiggyVue } from 'ziggy';
import { Ziggy } from 'ziggy';
// import bootbox from 'bootbox'
window.bootbox = window.JQuery = require("bootbox")

Vue.use(ZiggyVue, Ziggy);

// componentes internos
import moment from "moment";
// define comportamentos para habilitar devtools
let desenvolvimento = true;

Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.config.devtools = desenvolvimento;
Vue.config.performance = desenvolvimento;
Vue.use(PrimeVue);
Vue.use(ToastService);
Vue.use(ConfirmationService);

Vue.use(VueAxios, axios)
// Vue.axios.defaults.baseURL = '/apikkkkkkkk/';

Vue.component('Toast', Toast);
Vue.directive('tooltip', Tooltip);
new Vue({
    el: '#appsobdemanda',
    components: {
        Toast, Alert,
        'el-cartao': Cartao,
        'el-cartaomensagem': CartaoMensagem,
        'el-registrar': Registrar,
    }
})

Vue.filter("formatNumber", function (value, decimals) {
    if (value === '') {
        return value;
    }
    if (decimals == undefined) {
        decimals = 2;
    }
    const numValue = parseFloat(value);

    // const fmtValue = Number(Math.round(numValue+'e'+decimals)+'e-'+decimals).toFixed(decimals);
    const fmtValue = new Intl.NumberFormat("pt-BR",
        { style: "decimal", useGrouping: false, minimumFractionDigits: decimals }).format(value);

    return fmtValue;
});

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'R$',
        minimumFractionDigits: 0
    });
    return formatter.format(value);
});

Vue.filter('toNumber', (num) => {
    if (!num) {
        return '0.00';
    }
    const number = (num / 1).toFixed(2).replace(',', '.');
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
    }
});

Vue.filter('formatCPF', function (value) {
    if (!value) return ''
    let cpf = value.replace(/[^0-9]/g,'');
    cpf = cpf.substr(0, 3) + '.'+cpf.substr(3,3)+ '.'+cpf.substr(6,3)+'-'+cpf.substr(9,2);
    return cpf;
});

Vue.filter('mascaraCPF', function (value) {
    if (!value) return ''
    let cpf = value.replace(/[^0-9]/g,'');
    cpf = '***' + '.'+cpf.substr(3,3)+ '.'+cpf.substr(6,3)+'-'+'**';
    return cpf;
});

Vue.filter('formatCEP', function (value) {
    if (!value) return ''
    let cep = value.replace(/[^0-9]/g,'');
    // 30 110 012
    // 01 234 567
    cep = cep.substr(0, 2)
        + '.' + cep.substr(2,3)
        + '-' + cep.substr(5,3);
    return cep;
});

Vue.filter('formatCNPJ', function (value) {
    if (!value) return ''
    let cnpj = value.replace(/[^0-9]/g,'');
    // 11 274 939 0001 60
    // 01 234 567 8901 23
    // console.dir(cnpj);
    // console.dir(value.substr(3, 3));
    cnpj = cnpj.substr(0, 2)
        + '.' + cnpj.substr(2,3)
        + '.' + cnpj.substr(5,3)
        + '/' + cnpj.substr(8,4)
        + '-' + cnpj.substr(12,2);
    return cnpj;
});

Vue.component("el-modal",{
    props:['titulo', 'mensagem', 'size'],
    template:`
		<div class="modal fade in modal-active {{size ? 'modal-' + size : ''}}" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-dialog-scroll" style="" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<button type="button" @click="$emit('close')" class="close"><span aria-hidden="true">&times;</span></button>
							<h4 class="modal-title">
								{{titulo}}
							</h4>
						</div>
						<div class="modal-body">
							<div v-html="mensagem"></div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-default" @click="$emit('close')">Fechar</button>
						</div>
				</div>
			</div>
		</div>`
});

Vue.component("el-loader",{
    props:[],
    template:`
		<div class="modal fade in modal-active" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-dialog-scroll" style="" role="dialog">
					<div class="modal-content">
						<div class="modal-body" style="height: 180px">
                           <div id="loader"></div>
						</div>
				   </div>
			</div>
		</div>`
});

Vue.directive('el-datepicker', {
    bind: function () {
        var vm = this.vm;
        var key = this.expression;
        $(this.el).datepicker({
            dateFormat: 'dd/mm/yyyy',
            onClose: function (date) {
                if (date.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-\.](0?[1-9]|1[012])[\/\-\.]\d{4}$/))
                    vm.$set(key, date);
                else {
                    vm.$set(key, "");
                    console.log('data inválida');
                }
            }
        });
    },
    update: function (val) {
        $(this.el).datepicker('setDate', val);
    }
});

Vue.component('datepicker', {
    props: ['value'],
    mounted: function () {
        // activate the plugin when the component is mounted.
        $(this.$el).datepicker({
            dateFormat: 'dd.mm.yy',
            onClose: this.onClose
        })
    },
    methods: {
        // callback for when the selector popup is closed.
        onClose(date) {
            this.$emit('input', date) //maybe you need to validate something here? Dont knwo the plugin well enough.
        }
    },
    watch: {
        // when the value fo the input is changed from the parent,
        // the value prop will update, and we pass that updated value to the plugin.
        value(newVal) {
            $(this.el).datepicker('setDate', newVal);
        }
    }
});

// $('[data-toggle="tooltip"]').tooltip();
console.log("Inicializando VueJS (app.vue.js)......");
